var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 5,
    r: 4,
    stroke: "#0E2235",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15.9375C2.25 13.9009 3.90095 12.25 5.9375 12.25H14.0625C16.099 12.25 17.75 13.9009 17.75 15.9375C17.75 16.9385 16.9385 17.75 15.9375 17.75H4.0625C3.06148 17.75 2.25 16.9385 2.25 15.9375Z",
    stroke: "#0E2235",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.318fb0b13bec690747b6a54a599405c7.svg";
export { ForwardRef as ReactComponent };